import p5 from "p5";
import { DrawerBase } from './DrawerBase';
import { QTreeDrawer } from './QTreeDrawer';
import { GridDrawer } from './GridDrawer';
import { KTreeDrawer } from './KTreeDrawer';
import { Params } from '../../data/Params';
import { BitmapData } from '../image/BitmapData';
import { QTreeImgDrawer } from './QTreeImgDrawer';
import { QTreeRect } from './QTreeRect';



export class Drawers {

    //いくつかの表示ルールを切り替える
    index           :number = 0;
    currentDrawer   :DrawerBase;
    image           :BitmapData;
    callback        :()=>void;

    public init(callback:()=>void){

        this.callback = callback;
        /*
        this.image = new BitmapData();
        this.image.init("./ah.png","cameraman",512,512,()=>{
            //console.log("onload!")
            //callback();
            this._onInit();
        });*/
        this._onInit();

    }

    _onInit():void{
        
        //console.log("onInit!!!!")
        this.callback();

    }

    public show(tgt:p5){

        //Params.divisionId = 2;

        switch(Params.divisionId){
            case 0:
                this.currentDrawer = new QTreeDrawer(tgt);     
                break;
            case 1:
                this.currentDrawer = new KTreeDrawer(tgt);                           
                break;
            case 2:
                this.currentDrawer = new GridDrawer(tgt);
                break;
        }

        this.currentDrawer.show();

    }

    public hide(){

    }

    public getRects():QTreeRect[]{
        
        return this.currentDrawer.rects;

    }

    public reset(){

        this.currentDrawer?.hide();
        this.currentDrawer?.reset();

    }

    public update(){
        
        if(this.currentDrawer==null){
            console.log("ない " + this.currentDrawer)
        }
        this.currentDrawer?.update();

    }

}